import type {
  JobApplicationReceipt,
  JobApplicationReceiptResponse,
} from '@mds/shared/types/job-application';

import { api } from '@/lib/api';

import type { CareersApplication } from './careers.schema';

/**
 * Sends a careers application: the four fields and the CV, as
 * `multipart/form-data`. One per applicant per month, matched on email or
 * phone (`409 JOB_APPLICATION_MONTHLY_LIMIT`); the route is rate-limited per IP.
 */
export const sendApplication = (application: CareersApplication): Promise<JobApplicationReceipt> => {
  const body = new FormData();
  body.append('fullName', application.fullName);
  body.append('email', application.email);
  body.append('phone', application.phone);
  body.append('field', application.field);
  body.append('cv', application.cv);
  return api.post<JobApplicationReceiptResponse>('applications', body).then((r) => r.data);
};
